import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import MobileHeaderOnly from "components/headers/light.js";
import RecommendOfficeComponent from "salad/RecommendOfficeComponent";
import RecommendOfficeForm from "salad/RecommendOfficeForm";
import GrainFooter from "salad/GrainFooter";

export default () => {
    return (
        <div style={{ backgroundColor: "#FFFBDC", minHeight: "100vh" }}>
            <MobileHeaderOnly />
            <AnimationRevealPage>
                <RecommendOfficeComponent />
                <RecommendOfficeForm />
                <GrainFooter />
            </AnimationRevealPage>
        </div>
    );
};
